import React from 'react'
import { QRCode as QRCodeComponent } from 'react-qrcode-logo'
import PropTypes from 'prop-types'

import { StyledQRContainer } from './styles'

export const QRCode = ({ value, size, ...props }) => {
  return (
    <StyledQRContainer>
      <QRCodeComponent
        {...props}
        value={value}
        size={size}
        eyeRadius={[
          [12, 12, 0, 12],
          [12, 12, 12, 0],
          [12, 0, 12, 12],
        ]}
      />
    </StyledQRContainer>
  )
}

QRCode.defaultProps = {
  value: '',
  size: 250,
}

QRCode.propTypes = {
  value: PropTypes.any.isRequired,
  size: PropTypes.number,
}
